import clsx from 'clsx'
import useHackLink from 'hooks/useHackLink'
import useSlug, { isContentOnlyStored } from 'hooks/useSlug'
import { withTrailingSlash } from 'lib/utils'
import { ReactNode, type AnchorHTMLAttributes } from 'react'

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string
  replace?: boolean
  scroll?: boolean
  shallow?: boolean
  className?: string
  children: ReactNode
  // passHref?: boolean
  // prefetch?: boolean
  // locale?: string | false
}

let IntLink = ({
  href: rawHref,
  replace,
  scroll,
  shallow = true,
  className,
  children,
  ...props
}: Props) => {
  let handleClick = useHackLink()
  let href = withTrailingSlash(rawHref)
  let { showOnlyContent } = useSlug()

  // В режиме content-only (webview приложения) параметр прописывается
  // прямо в href: полная перезагрузка по ссылке (в т.ч. при мёртвом
  // React после инжект-скрипта приложения) сразу получает от SSR
  // версию без шапки/подвала. Меняется только атрибут — для гидрации
  // безопасно (React 17 не патчит атрибуты).
  let contentOnly = showOnlyContent || isContentOnlyStored()
  let hrefX =
    contentOnly &&
    href.indexOf('/') === 0 &&
    !href.includes('#') &&
    !href.includes('content-only=')
      ? `${href}${href.includes('?') ? '&' : '?'}content-only=1`
      : href

  return (
    <a
      href={hrefX}
      className={clsx(className)}
      onClick={(e) =>
        handleClick(e, hrefX, { replace, scroll, shallow })
      }
      {...props}
    >
      {children}
    </a>
  )
}

export default IntLink
